var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    [
      _c(
        "job-preview-content-outline",
        _vm._g(
          { attrs: { title: "仕事内容", "data-test": "job" } },
          _vm.$listeners
        ),
        [
          _c(
            "job-preview-content",
            _vm._g(
              {
                attrs: {
                  "comment-highlights": _vm.getAnyCommentHighlights(
                    _vm.targetIdMap.description.job.prefix
                  ),
                  "text-count-mode": _vm.textCountMode,
                  "highlight-mode": _vm.highlightMode,
                  "text-counts": _vm.textCounts.job,
                  "target-id": _vm.targetIdMap.description.job.detail,
                  value: _vm.description.detail,
                  "data-test": "job-content",
                },
                scopedSlots: _vm._u(
                  [
                    _vm.description.catchCopy
                      ? {
                          key: "catch",
                          fn: function () {
                            return [
                              _c("p", {
                                staticClass:
                                  "fwB margin-bottom-1 pega-pre-wrap",
                                attrs: {
                                  id: _vm.targetIdMap.description.job.catchCopy,
                                  "data-test": "catch-copy",
                                },
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.description.catchCopy
                                  ),
                                },
                              }),
                            ]
                          },
                          proxy: true,
                        }
                      : null,
                  ],
                  null,
                  true
                ),
              },
              _vm.$listeners
            )
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.description.workflow
        ? _c(
            "job-preview-content-outline",
            _vm._g(
              {
                attrs: {
                  title: "一日の仕事の流れ",
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.description.workflow
                  ),
                  "text-count-mode": _vm.textCountMode,
                  "highlight-mode": _vm.highlightMode,
                  "text-counts": [
                    _vm.getTextCount(
                      "一日の仕事の流れ",
                      _vm.description.workflow,
                      _vm.targetIdMap.description.workflow
                    ),
                  ],
                  "target-id": _vm.targetIdMap.description.workflow,
                  value: _vm.description.workflow,
                  "data-test": "workflow",
                },
              },
              _vm.$listeners
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShow.attentions
        ? _c(
            "job-preview-content-outline",
            _vm._g(
              { attrs: { title: "仕事の魅力", "data-test": "attentions" } },
              _vm.$listeners
            ),
            _vm._l(_vm.attentionsNotEmpty, function (attention, key, index) {
              return _c(
                "job-preview-content",
                _vm._g(
                  {
                    key: key,
                    attrs: {
                      "comment-highlights": _vm.getAnyCommentHighlights(
                        _vm.targetIdMap.description.attention.prefix,
                        key
                      ),
                      "text-count-mode": _vm.textCountMode,
                      "highlight-mode": _vm.highlightMode,
                      "text-counts": _vm.textCounts.attention(key),
                      "target-id":
                        _vm.targetIdMap.description.attention.text + "-" + key,
                      value: attention.text,
                      "value-class":
                        index !== Object.keys(_vm.attentionsNotEmpty).length - 1
                          ? "mb15"
                          : "",
                      "data-test": "attention-" + key,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "catch",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "mb5" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "point fs12",
                                    attrs: { "data-test": "point-" + key },
                                  },
                                  [_vm._v("POINT0" + _vm._s(key))]
                                ),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "fwB",
                                  attrs: {
                                    id:
                                      _vm.targetIdMap.description.attention
                                        .title +
                                      "-" +
                                      key,
                                    "data-test": "attention-title-" + key,
                                  },
                                  domProps: {
                                    textContent: _vm._s(attention.title),
                                  },
                                }),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  _vm.$listeners
                )
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShow.improved
        ? _c(
            "job-preview-content-outline",
            _vm._g(
              {
                attrs: {
                  title: "この仕事で磨ける経験・能力",
                  "comment-highlights": _vm.getCommentHighlights(
                    _vm.targetIdMap.description.improved
                  ),
                  "text-count-mode": _vm.textCountMode,
                  "highlight-mode": _vm.highlightMode,
                  "text-counts": [
                    _vm.getTextCount(
                      "この仕事で磨ける経験・能力",
                      _vm.description.improved,
                      _vm.targetIdMap.description.improved
                    ),
                  ],
                  "target-id": _vm.targetIdMap.description.improved,
                  value: _vm.description.improved,
                  "data-test": "improved",
                },
              },
              _vm.$listeners
            )
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isShow.strengths
        ? _c(
            "job-preview-content-outline",
            _vm._g(
              {
                attrs: { title: "アピールポイント", "data-test": "strengths" },
              },
              _vm.$listeners
            ),
            _vm._l(_vm.strengthsNotEmpty, function (value, key, index) {
              return _c(
                "job-preview-content",
                _vm._g(
                  {
                    key: key,
                    attrs: {
                      "comment-highlights": _vm.getCommentHighlights(
                        _vm.targetIdMap.description.strength[key]
                      ),
                      "text-count-mode": _vm.textCountMode,
                      "highlight-mode": _vm.highlightMode,
                      "text-counts": [
                        _vm.getTextCount(
                          _vm.strengthTitle[key],
                          _vm.description.strengths[key],
                          _vm.targetIdMap.description.strength[key]
                        ),
                      ],
                      "target-id": _vm.targetIdMap.description.strength[key],
                      value: value,
                      "value-class":
                        index !== Object.keys(_vm.strengthsNotEmpty).length - 1
                          ? "mb15"
                          : "",
                      "data-test": "strength-" + key,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "catch",
                          fn: function () {
                            return [
                              _c("div", { staticClass: "mb5" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "apoint fs12",
                                    attrs: {
                                      "data-test": "strength-title-" + key,
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.strengthTitle[key]))]
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  _vm.$listeners
                )
              )
            }),
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }